import React from "react";
import styled from "styled-components";
import TestimonialSlider from "../Elements/TestimonialSlider";
import FAQSection from "../Elements/FAQSection";

const BlogV2 = () => {
  return (
    <Wrapper id="Aide & Avis" style={{ marginTop: "50px" }}>
      <div className="container">
        <HeaderInfo>
          <h1 className="font40 extraBold">Ce Qu'ils Disent</h1>
          <p className="font13">
            Rejoignez les milliers d’apprenants qui nous font confiance !
            <br /> Découvrez les témoignages de nos étudiants et partenaires, et
            voyez pourquoi ils choisissent ValAcademy pour développer leurs
            compétences et booster leur avenir professionnel.
          </p>
        </HeaderInfo>
        <TestimonialSlider />
      </div>
      <h1
        className="font40 extraBold"
        style={{
          color: "#225c2e",
          textAlign: "center",
          marginTop: "50px",
          fontSize: "3.5rem",
        }}
      >
        FAQ
      </h1>
      <FlexContainer className="container">
        <FAQHeader>
          <p
            className="font13"
            style={{ fontSize: "0.9rem", marginTop: "12%" }}
          >
            Vous avez des questions ? Nous avons les réponses !
            <br />
            <br />
            Consultez notre FAQ pour trouver des réponses aux questions les plus
            fréquemment posées.
          </p>
        </FAQHeader>
        <FAQSection />
      </FlexContainer>
    </Wrapper>
  );
};
export default BlogV2;

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  margin-top: 50px;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FAQHeader = styled.div`
  margin-bottom: 20px;
  max-width: 35%; /* Default width on large screens */

  p {
    margin: 0;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    max-width: 100%; /* Full width on mobile */
    text-align: center; /* Optionally center the text on mobile */
  }
`;
